import React from "react";
import CounterUp from "../helpers/CounterUp";

export default function CounterSection() {
  return (
    <>
      <div
        className="cournter-section-five bg-black text-white py-65 rpt-75 rpb-45"
        id="cournter-section-five"
      >
        <div className="container-fluid clearfix px-70">
          <div className="grid-container text-center grid-item-center">
            <div className="grid-item right-border">
              <div className="success-item style-five wow fadeInUp delay-0-2s">
                <div className="icon">
                  <img
                    src={require(`../../assets/images/counter/icon1.png`)}
                    alt="Icon"
                  />
                </div>
                <div className="content">
                  <span className="count-text k">DPIIT No: DIPP159126</span>
                  <span>Recognised by the Central Government of India.</span>
                </div>
              </div>
            </div>
            <div className="grid-item right-border">
              <div className="success-item style-five wow fadeInUp delay-0-4s">
                <div className="icon">
                  <img
                    src={require(`../../assets/images/counter/icon2.png`)}
                    alt="Icon"
                  />
                </div>
                <div className="content">
                  <span className="count-text k">ISO Certified</span>
                  <span>Certificate No: 24EQMR61</span>
                </div>
              </div>
            </div>
            <div className="grid-item">
              <div className="success-item style-five no-border wow fadeInUp delay-0-6s">
                <div className="icon">
                  <img
                    src={require(`../../assets/images/counter/icon3.png`)}
                    alt="Icon"
                  />
                </div>
                <div className="content">
                  <span className="count-text plus">UDYAM Registration</span>
                  <span>Certificate No: UDYAM-UP-28-0074138</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
